import { useContext } from 'react'

import { FileContext } from '../File.context'

export const useFileContext = () => useContext(FileContext)
